// extracted by mini-css-extract-plugin
module.exports = {"loginWrapper":"login_loginWrapper__1gmYo","form":"login_form__3PzP_","userAvatar":"login_userAvatar__1dPUT"};